export const staticData = {
  bases: ['Role Based', 'Request Based'],
  typeOfRequest: [
    { label: 'Costing', value: 'Costing' },
    { label: 'Transfer Pricing', value: 'Transfer Pricing' },
  ],
};

export const isTransferPricing = (type_of_request) => type_of_request === 'Transfer Pricing';
export const isRequestBased = (base) => base === 'Request Based';
